import * as PropTypes from 'prop-types';
import * as React from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any, react/forbid-prop-types */

var HelpText = props => {
  if (typeof props.children === 'string') {
    return /*#__PURE__*/React.createElement("p", {
      id: "".concat(props.id, "-helptext"),
      className: "form-text"
    }, props.children);
  }
  var hcid = "".concat(HelpText.name.toLocaleLowerCase(), "-").concat("10.6.2");
  return /*#__PURE__*/React.createElement("div", {
    id: "".concat(props.id, "-helptext"),
    className: "form-text",
    "data-hcid": hcid
  }, props.children);
};
HelpText.propTypes = {
  children: PropTypes.any.isRequired,
  id: PropTypes.string.isRequired
};

export { HelpText };
